import { render, staticRenderFns } from "./NoticeItem.vue?vue&type=template&id=149d908a&scoped=true&"
import script from "./NoticeItem.vue?vue&type=script&lang=js&"
export * from "./NoticeItem.vue?vue&type=script&lang=js&"
import style0 from "./NoticeItem.vue?vue&type=style&index=0&id=149d908a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149d908a",
  null
  
)

export default component.exports